<template>
  <div>
    <Card>
      <template #title>Событие №{{ event.id }}</template>
      <template #content>
        <p><strong>ID: </strong>{{ event.id }}</p>
        <p><strong>Дата события: </strong>{{ event.eventDate }}</p>
        <p><strong>Дата создания: </strong>{{ dateService.dateToString(event.createdAt) }}</p>
        <p><strong>Временная зона: </strong>{{ event.locale }}</p>
        <Divider></Divider>
        <p><strong>ЦБ УИД: </strong>{{ event.cbUuid }}</p>
        <Divider></Divider>
        <p><strong>Версия формата Эквифакс: </strong>{{ formats.equ }}</p>
        <p><strong>Версия формата НБКИ: </strong>{{ formats.nbki }}</p>
        <p><strong>Тип: </strong>{{ compendiumService.getValueByCode($store.state.compendiums.eventType, event.type) }}</p>
        <p><strong>Тип отправки: </strong>{{ event.sendType }}</p>
      </template>
      <template #footer>
<!--        <SplitButton label="Действия" icon="pi pi-bolt" :model="getActions()"></SplitButton> TODO вернуть после проверки ЦБ-->
      </template>
    </Card>
  </div>
</template>

<script>
import FilterDateService from "@/service/FilterDateService";
import CompendiumService from "@/service/CompendiumService";

export default {
  name: "EventGeneral",
  props: {
    event: {
      type: Object,
      required: true
    },
    formats: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dateService: FilterDateService,
      compendiumService: CompendiumService,
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>